import styled from "styled-components";

const VideoListJackpotContainerDefaultBox = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 1.2rem;
  margin-top: 5px;
  @media ${({theme}) => theme.mediaQuery.xlAndBelow } {
    margin-left: 0.5rem;
  }
`;

export const VideoListJackpotContainerBox = VideoListJackpotContainerDefaultBox;